/**
 * Join path segments into an endpoint path.
 *
 * Always absolute: every `API_ROUTES` entry is, and the API provider
 * concatenates onto the base URL rather than using `new URL(path, base)` (which
 * would discard the base's own `/api` prefix), so a consistent leading slash
 * keeps the two halves from doubling or dropping one.
 *
 * Accidental double slashes collapse, and ids may be numbers because Laravel's
 * primary keys are integers.
 *
 * @example buildPath("/v1/admin/games", 11) // "/v1/admin/games/11"
 */
export function buildPath(...segments: (string | number)[]): string {
  const parts = segments
    .flatMap((segment) => String(segment).split("/"))
    .filter(Boolean);

  return `/${parts.join("/")}`;
}
